import { Navigate, Outlet } from "react-router-dom";
import { getAdminToken } from "../admin/adminApi";

export default function AdminRoute() {
  const token = getAdminToken();
  if (!token) {
    return <Navigate to="/admin" replace />;
  }
  return <Outlet />;
}
